import { useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import _get from 'lodash/get';

const useView = () => {
	const [showLoader, setShowLoader] = useState(false);
	const history = useHistory();
	const location = useLocation();

	const handleFormSubmit = () => {};

	const handleFormCancel = () => {
		history.goBack();
	};

	return { data: _get(location, ['state', 'rowData']), showLoader, handleFormSubmit, handleFormCancel, setShowLoader };
};

export default useView;
